var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotarizeIt = function SvgNotarizeIt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "notarizeIt_svg__Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 375.29 362.78"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".notarizeIt_svg__cls-1{fill:#b782ff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notarizeIt_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.29 121.39h-89.27s-41.09-.02-39.45-53.29c-.7-62.22-.65-65.42-.65-65.42h-74.01V103.3s-7.24 87.76 67.52 94.65h135.86v-76.57ZM.35 244.07h89.27s41.09.02 39.45 53.29c.7 62.22.65 65.42.65 65.42h74.01V262.16s7.24-87.76-67.52-94.65H.35v76.57ZM45.97 101.06c25.39 0 45.97-19.19 45.97-42.88V0H0v58.17c0 23.7 20.58 42.88 45.97 42.88ZM329.32 362.78c25.39 0 45.97-19.19 45.97-42.88v-58.17h-91.94v58.17c0 23.7 20.58 42.88 45.97 42.88",
    className: "notarizeIt_svg__cls-1"
  }))));
};
export default SvgNotarizeIt;